export default __webpack_public_path__ + "static/media/Gellix-LightItalic.3c8af4de.woff";